/**
 * SFrame110 – Onboarding Video
 * Figma Frame 10 (node 1018:13711)
 *
 * "{Name}'s Estate Settlement" header. Card with explanatory text and embedded
 * video player. Skip and Done buttons.
 */

import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import videoPlayButton from '../../assets/images/video-play-button.svg';

interface LocationState {
  deceasedName?: string;
  estateId?: string;
}

export default function SFrame110() {
  const navigate = useNavigate();
  const location = useLocation();
  const { deceasedName, estateId } = (location.state as LocationState) || {};
  const [videoWatched, setVideoWatched] = useState(false);

  const handleContinue = () => {
    navigate('/sframe-111', { state: { deceasedName, estateId } });
  };

  const displayName = deceasedName || 'Your Loved One';

  return (
    <div className="min-h-screen flex flex-col">
      {/* Top header bar */}
      <div className="bg-dark-gradient py-3 px-6">
        <p className="text-center text-white-alt font-semibold text-base tracking-wide">
          {displayName}'s Estate Settlement
        </p>
      </div>

      {/* Cream to light-blue gradient background */}
      <div className="flex-1 flex items-center justify-center px-4 py-12 bg-gradient-to-b from-white to-blue-100">
        <div className="w-full max-w-[600px] bg-white-alt rounded-xl shadow-card p-8 sm:p-10">
          <p className="font-display text-lg sm:text-xl text-blue-900 mb-6 leading-relaxed">
            Before we get started, we want to give you a run down of the process.
            End of an Era strives to make this process as stress-free as possible.
          </p>

          {/* Video embed placeholder */}
          <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-black mb-6">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/placeholder?autoplay=0&rel=0"
              title="Settlement Process Overview"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              onLoad={() => setVideoWatched(true)}
            />
            {/* Play button overlay (shows when no video loaded) */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-14 h-14 rounded-full bg-white-alt/30 backdrop-blur-sm flex items-center justify-center">
                <img src={videoPlayButton} alt="Play" className="w-8 h-8 brightness-0 invert" />
              </div>
            </div>
          </div>

          {/* Skip / Done buttons */}
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={handleContinue}
              className="px-6 py-2.5 rounded-md font-medium text-sm text-grey-600 bg-grey-200 hover:bg-grey-300 transition-all"
            >
              Skip
            </button>
            <button
              onClick={handleContinue}
              className="px-6 py-2.5 rounded-md font-medium text-sm bg-blue-600 text-white-alt hover:bg-blue-900 transition-all"
            >
              {videoWatched ? 'Done' : 'Done'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
